<template>
<div class="chapter">
<div class="inner_page">
<div id="Illustrations">
<p class="fm-title"><b>Illustrations</b><span epub:type="pagebreak" id="pageix"></span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_1" title="Link target outside of Sample">The 8th Duke of Hamilton (centre) with Dr Moore (left) and the young John Moore (right)</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_2" title="Link target outside of Sample">Sir John Moore by Sir Thomas Lawrence</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_3" title="Link target outside of Sample">Monument to Sir John Moore in Glasgow</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_4" title="Link target outside of Sample">The Battle of Alexandria</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_5" title="Link target outside of Sample">Sir Ralph Abercromby</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_6" title="Link target outside of Sample">William Pitt the Younger</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_7" title="Link target outside of Sample">Pasquale Paoli</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_8" title="Link target outside of Sample">Gilbert Elliot, 1st Earl of Minto</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_9" title="Link target outside of Sample">Admiral Samuel Hood</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_10" title="Link target outside of Sample">Frederick, Duke of York</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_11" title="Link target outside of Sample">George Canning</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_12" title="Link target outside of Sample">Viscount Castlereagh</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_13" title="Link target outside of Sample">Shorncliffe Camp</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_14" title="Link target outside of Sample">Map of Shorncliffe Camp</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_15" title="Link target outside of Sample">Sir David Baird</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_16" title="Link target outside of Sample">British troops on the retreat to Corunna</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_17" title="Link target outside of Sample">Nicolas Jean-de-Dieu Soult</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_18" title="Link target outside of Sample">Arthur Wellesley, 1st Duke of Wellington</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_19" title="Link target outside of Sample">Sir John Moore receives his death wound</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_20" title="Link target outside of Sample">Sir John Moore’s tomb at Corunna</span></p>
<p class="list-fig"><span href="#/xhtml/19_Photo_Gallery#plate_21" title="Link target outside of Sample">Monument to Sir John Moore, St Paul’s Cathedral, London</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Illustrations.vue?15508f66